"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));
var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createSuper"));
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _Form = _interopRequireDefault(require("react-bootstrap/Form"));
var _InputGroup = _interopRequireDefault(require("react-bootstrap/InputGroup"));
var _CompletedContext = require("../CompletedContext");
var _reactUseIdHook = require("react-use-id-hook");
var _excluded = ["state", "setState"];
function TaskBlankForm(_ref) {
  var state = _ref.state,
    setState = _ref.setState,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var id = (0, _reactUseIdHook.useId)();
  var invalid = state.text.length >= props.answer.length && !state.completed;
  return /*#__PURE__*/_react.default.createElement(_Form.default, {
    key: props.key,
    className: "task task-blank" + (props.srLabel ? " sr-label" : ""),
    style: (0, _objectSpread2.default)({
      display: props.inline ? 'inline-block' : undefined
    }, props.style),
    inline: props.inline,
    onSubmit: function onSubmit(e) {
      e.preventDefault();
    }
  }, /*#__PURE__*/_react.default.createElement(_Form.default.Group, {
    key: props.key + "Group"
  }, /*#__PURE__*/_react.default.createElement(_Form.default.Label, {
    htmlFor: id
  }, props.label), /*#__PURE__*/_react.default.createElement(_InputGroup.default, {
    className: props.inline ? "mx-2" : undefined
  }, props.prepend && /*#__PURE__*/_react.default.createElement(_InputGroup.default.Prepend, null, /*#__PURE__*/_react.default.createElement(_InputGroup.default.Text, null, props.prepend)), /*#__PURE__*/_react.default.createElement(_Form.default.Control, {
    key: props.key + "Control",
    type: "text",
    id: id,
    "aria-describedby": (props.description ? "description-" + id + " " : "") + (invalid ? "error-" + id : ""),
    placeholder: props.placeholder,
    value: state.text,
    onChange: function onChange(e) {
      setState({
        text: e.target.value
      });
    },
    isValid: state.completed,
    isInvalid: invalid,
    "aria-invalid": invalid,
    disabled: state.completed
  })), props.description && /*#__PURE__*/_react.default.createElement("span", {
    id: "description-" + id
  }, props.description), invalid && /*#__PURE__*/_react.default.createElement("span", {
    className: "error",
    id: "error-" + id
  }, "Incorrect. Please correct your answer to continue.")));
}
var TaskBlank = exports.default = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(TaskBlank, _Component);
  var _super = (0, _createSuper2.default)(TaskBlank);
  function TaskBlank(props) {
    var _this;
    (0, _classCallCheck2.default)(this, TaskBlank);
    _this = _super.call(this, props);
    _this.state = props.state || {};
    if (!_this.state.initialized) {
      _this.state.initialized = true;
      // Initial state is set here, since the constructor can be called more than once.
      _this.state.completed = false;
      _this.state.text = "";
    }
    return _this;
  }
  (0, _createClass2.default)(TaskBlank, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevprops, prevstate, snapshot) {
      if (prevstate.completed !== this.state.completed || prevstate.taskId !== this.state.taskId) {
        // Make sure our parent knows about the completion
        this.context.onCompleted(this.state.completed, this.state.taskId);
      }
      for (var _i = 0, _Object$keys = Object.keys(this.state); _i < _Object$keys.length; _i++) {
        var key = _Object$keys[_i];
        // Keep our stored state synchronized
        if (this.state[key] !== this.props.state[key]) {
          this.props.state[key] = this.state[key];
        }
      }
      var completed = this.state.text.toLowerCase() === this.props.answer.toLowerCase();
      if (this.state.completed !== completed) {
        this.setState({
          completed: completed
        });
      }
    }
  }, {
    key: "isTask",
    value: function isTask() {
      return true;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      // Notify the parent of our completion status
      this.context.registerTask(function (id) {
        _this2.setState({
          taskId: id
        });
      });
      this.context.onCompleted(this.state.completed, this.state.taskId);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      if (!this.props.label) {
        throw new Error("TaskBlank: prop 'label' must be specified.");
      }
      return /*#__PURE__*/_react.default.createElement(TaskBlankForm, Object.assign({}, this.props, {
        state: this.state,
        setState: function setState() {
          return _this3.setState.apply(_this3, arguments);
        }
      }));
    }
  }]);
  return TaskBlank;
}(_react.Component);
TaskBlank.contextType = _CompletedContext.CompletedContext;